var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"max-w-7xl w-full px-5 lg:px-1 md:mx-auto"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }